import { TextField, InputAdornment, CircularProgress } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from '@material-ui/lab';
import debounce from 'lodash/debounce';

import { openModal } from 'features/utilsSlice';
import SearchIcon from 'public/icons/search-main.svg';
import ToDoList from './ToDoList';
import MultiSelect from 'components/MultiSelect';
import Header from 'components/agency/Header';
import styles from 'styles/components/agency/Dashboard.module.scss';

const ToDosMask = ({
  title,
  todos,
  setTodos,
  isLoading,
  selectedNetworkIds,
  setSelectedNetworkIds,
  setSearchValue,
  searchValue,
}) => {
  const dispatch = useDispatch();
  const networks = useSelector(state => state.utils.networks);
  const handleUpdateTodo = todo => {
    if (todo.status === 'awaiting_approval') {
      setTodos(prevTodos => prevTodos.filter(oldTodo => oldTodo.id !== todo.id));
    } else {
      setTodos(prevTodos =>
        prevTodos.map(oldTodo => (oldTodo.id === todo.id ? { ...oldTodo, ...todo } : oldTodo))
      );
    }

    dispatch(openModal({ name: 'New Milestone', data: { milestone: todo } }));
  };

  return (
    <div className={styles.container}>
      <Header title="ToDos" />

      <div className={styles.content}>
        <h2>{title}</h2>

        <div className={styles.filters} style={{ flexWrap: 'noWrap' }}>
          <TextField
            initialValue={searchValue}
            onChange={debounce(e => setSearchValue(e.target.value), 1000)}
            type="text"
            variant="outlined"
            placeholder="Search for client"
            className={styles.input}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />

          <MultiSelect
            menuItems={networks}
            setSelectedItems={setSelectedNetworkIds}
            selectedItems={selectedNetworkIds}
          />
        </div>

        {isLoading && <CircularProgress color="primary" />}

        {!isLoading && todos.length === 0 && <Alert severity="info">No ToDos</Alert>}

        {!isLoading && todos.length > 0 && (
          <ToDoList todos={todos} handleUpdateTodo={handleUpdateTodo} />
        )}
      </div>
    </div>
  );
};

export default ToDosMask;
